import {FilterData, Filtro} from './components/interfaces';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/index';
import {Injectable} from '@angular/core';
import {DomainBase} from './utils/utils';
import {map} from "rxjs/operators";
import { environment  } from "./environments/environment";
import * as stringifyCustom from 'json-stringify-safe';
import {FileItem} from "ng2-file-upload";
import {ContaReceber} from "./entidades/contareceber/contareceber";
import {FilterDataHql} from "./shared/filterdata/filter-data-hql";

export class ServerResponse<T extends DomainBase> {
  content: any;
  filterData: FilterData;
  success: boolean;
  message: string;
}

@Injectable()
export abstract class CommonsService<T extends DomainBase> {

  protected API_ROOT_URL = environment.getBaseURL();
  reportName = "";

  constructor(public http: HttpClient) {
  }

  abstract getPathModule(): string;

  public loadByFilter(filterData: FilterData): Observable<ServerResponse<T>> {
    return this.http.post<ServerResponse<T>>(`${this.API_ROOT_URL}/${this.getPathModule()}/`, filterData);
  }

  public save(bean: DomainBase): Observable<ServerResponse<T>> {
    console.log(bean);
    return this.http.post<ServerResponse<T>>(`${this.API_ROOT_URL}/${this.getPathModule()}/save`, JSON.parse(stringifyCustom(bean)));
  }

  public saverefis(bean: DomainBase, id: number): Observable<ServerResponse<T>> {
    console.log(bean);
    return this.http.post<ServerResponse<T>>(`${this.API_ROOT_URL}/${this.getPathModule()}/refinanciar/${id}`, JSON.parse(stringifyCustom(bean)));
  }

  public busca(filtro: Filtro): Observable<ServerResponse<T>> {
    return this.http.post<ServerResponse<T>>(`${this.API_ROOT_URL}/`+ filtro.tipo +`/busca`, filtro);
  }

  public quitarparcelas(bean: DomainBase, qtd: number): Observable<ServerResponse<T>> {
    console.log(bean);
    return this.http.post<ServerResponse<T>>(`${this.API_ROOT_URL}/${this.getPathModule()}/quitarparcelas/${qtd}`, JSON.parse(stringifyCustom(bean)) );
  }

  public getbyassociacao(bean: any): Observable<ServerResponse<T>> {
    console.log(bean);
    return this.http.post<ServerResponse<T>>(`${this.API_ROOT_URL}/${this.getPathModule()}/getbalanco`, JSON.parse(stringifyCustom(bean)));
  }

  public getcontareceber(bean: any): Observable<ServerResponse<T>> {
    console.log(bean);
    return this.http.post<ServerResponse<T>>(`${this.API_ROOT_URL}/${this.getPathModule()}/getcontasreceber`, JSON.parse(stringifyCustom(bean)));
  }

  public importcsv(content: string[]): Observable<ServerResponse<T>> {
    return this.http.post<ServerResponse<T>>(`${this.API_ROOT_URL}/${this.getPathModule()}/importcsv`, content);
  }

  public espelhoretorno(): Observable<ServerResponse<T>> {
    return this.http.post<ServerResponse<T>>(`${this.API_ROOT_URL}/${this.getPathModule()}/importar`, "01");
  }

  public importretornoalba(): Observable<ServerResponse<T>> {
    return this.http.post<ServerResponse<T>>(`${this.API_ROOT_URL}/${this.getPathModule()}/importretornoalba`, "01");
  }

  public loadQuery(filterData: FilterData, queryId: string): Observable<ServerResponse<T>> {
    return this.http.post<ServerResponse<T>>(`${this.API_ROOT_URL}/${this.getPathModule()}/q/${queryId}`, filterData);
  }

  public findById(id: string): Observable<ServerResponse<T>> {
    return this.http.get<ServerResponse<T>>(`${this.API_ROOT_URL}/${this.getPathModule()}/${id}`);
  }


  public findOcorrenciaById(id: string): Observable<ServerResponse<T>> {
    return this.http.get<ServerResponse<T>>(`${this.API_ROOT_URL}/${this.getPathModule()}/${id}`);
  }

  public getView(id: string): Observable<ServerResponse<T>> {
    return this.http.get<ServerResponse<T>>(`${this.API_ROOT_URL}/${this.getPathModule()}/getview/${id}`);
  }

  public delete(id: string): any {
    return this.http.delete<ServerResponse<T>>(`${this.API_ROOT_URL}/${this.getPathModule()}/${id}`);
  }

  public hashCode(value): any {
    var h = 0, l = value.length, i = 0;
    if (l > 0)
      while (i < l)
        h = (h << 5) - h + value.charCodeAt(i++) | 0;
    return h;
  };

  printReport(reportName: string){
    this.reportName = reportName;

    if(this.reportName !== null && this.reportName !== ""){
      this.downloadPDF().subscribe(
        (res) => {
          var fileURL = URL.createObjectURL(res);
          window.open(fileURL);
        }
      );
    }
  }

  downloadPDF(): any {
    let filter: FilterData = <FilterData>{
      page: 1,
      limit: 15,
      whereClauses: []
    };

    return this.http.post(this.API_ROOT_URL+'/reports/' + this.reportName, filter,{ responseType: 'blob'})
      .pipe(map(res => {
        return new Blob([res], { type: 'application/pdf', });
      }));
  }


  public loadByFilterHql(filter: FilterDataHql): Observable<ServerResponse<T>> {
    return this.http.post<ServerResponse<T>>(`${this.API_ROOT_URL}/${this.getPathModule()}/filter`, filter);
  }
}
